import { FormikHelpers } from 'formik';
import { API_ACCOUNT_CONTRACT_ADDITIONAL_INFO } from 'api/endpoints';
import { action } from 'mobx';
import { RootStore } from 'stores/rootStore';
import { FormStore } from '../../formStore';
import { AdditionalInfoData } from './model';
import { ContractTab } from 'pages/Accounts/Edit/Contract/Contract';

export class WorkflowAdditionalInfoStore extends FormStore<AdditionalInfoData> {
  accountId = '';

  constructor(rootStore: RootStore, accountId: string) {
    super(rootStore);
    this.accountId = accountId;
  }

  @action handleNext = async (
    tabChange: Function,
    data: AdditionalInfoData,
    formikHelpers: FormikHelpers<AdditionalInfoData>,
  ) => {
    const submitted = await this.handleSubmit(data, formikHelpers);
    if (submitted) {
      tabChange(ContractTab.DOCS);
    }
  };

  @action handleBack = (tabChange: Function) => {
    tabChange(ContractTab.AML);
  };

  fetchAdditionalInfoData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.fetchData(`${API_ACCOUNT_CONTRACT_ADDITIONAL_INFO(this.accountId)}`, {
      resetData: false,
    });
    this.rootStore.stores.uiStore.setLoading(false);
  };

  async handleSubmit(values: AdditionalInfoData, formikHelpers: FormikHelpers<AdditionalInfoData>): Promise<boolean> {
    return this.submitData(`${API_ACCOUNT_CONTRACT_ADDITIONAL_INFO(this.accountId)}`, values, {
      formikHelpers,
      singleValueResponse: true,
      validationPrefixDepth: 2,
      reset: false,
    });
  }
}
